import _ from 'underscore';
import $ from 'jquery';
import Cache from 'root/cache';
import Router from 'root/router';
import Util from 'root/module/util';
import UI from 'root/ui';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_Time_Usage from 'view/chart/feedback_time_usage';
import View_Feedback_Vote from 'chart/feedback_vote';
import View_Design_Files from 'chart/design_files';
import View_Feedback_Rating from 'chart/feedback_rating';
import View_Feedback_Top_User from 'chart/feedback_user';
import Chart_Feedback_Activity from 'chart/feedback_activity';
import View_Country from 'chart/feedback_country';
import View_Browser from 'chart/feedback_browser';
import View_Feedback_Type from 'view/dashboard/feedback_type';
import View_Feedback_Status from 'view/dashboard/feedback_status';
import View_Feedback_Assignee from 'view/dashboard/feedback_assignee';

const feedback_type_options = {
    'bug'             : 'Bug',
    'feature_request' : 'Idea',
    'general'         : 'General'
};

const page_conditions = {
    exact_url_match: 'URL exactly matches',
    url_contains: 'URL contains',
    url_start: 'URL start with',
    url_end: 'URL ends with',
    url_not: 'URL is not',
    url_contains_not: 'URL does not contain',
    url_regex: 'URL matches regex'
}

const Page_Dashboard = View.extend({
    tagName: 'main',
    className: 'xlarge',

    views: {
        country_chart: {},
        browser_chart: {},
        time_usage: {},
        top_user: {},
        top_vote: {},
        design_files: {},
        rating: {},
        feedback_type: {},
        feedback_status: {},
        feedback_assignee: {}
    },

    pending_xhr: [],

    events: {
        'click .days-activity li'            : 'rangeChangeFeedback',
        'click .days-usage li'               : 'rangeChangeUsage',
        'click .days-browser li'             : 'rangeChangeBrowser',
        'click .days-country li'             : 'rangeChangeCountry',
        'click .days-top-user li'            : 'rangeChangeTopUser',
        'click .onboarding-block'            : 'onClickPendingWidget',
        'click .widget-preview'              : 'onWidgetPreview',
        'click .widget-edit'                 : 'onWidgetEdit',
        'click .widget-toggle'               : 'onWidgetToggle',
        'click .try-extension'               : 'onTryExtension',
        'click .try-extension-close'         : 'onTryExtensionClose',
        'click .activate-portal'             : 'onActivatePortal',
        'click .ai-assist'                   : 'onActivateAIAssist'
    },

    dom_handlers: {
        onClickPendingWidget: function(e) {
            Router.navigate('/widget/', {trigger: true});
        },

        rangeChangeFeedback: function(e) {
            var days = parseInt($(e.currentTarget).data('value'), 10);

            this.$el.find('.days-activity .current-selection').text('Last ' + days + ' days');
            this.$el.find('.days-activity li').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            var xhr = Cache.app.request({
                action: 'statistics/report',
                data: {
                    days: days,
                    type: 'activity'
                },
                context: this,
                success: function(response) {
                    Chart_Feedback_Activity.render(this.$el.find('#chart_feedback'), response.activity);
                }
            });

            this.pending_xhr.push(xhr);
        },

        rangeChangeUsage: function(e) {
            var days = parseInt($(e.currentTarget).data('value'), 10);

            this.$el.find('.days-usage .current-selection').text('Last ' + days + ' days');
            this.$el.find('.days-usage li').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            var xhr = Cache.app.request({
                action: 'statistics/report',
                data: {
                    days: days,
                    type: 'usage'
                },
                context: this,
                success: function(response) {
                    this.renderUsageChart(response.usage);
                }
            });

            this.pending_xhr.push(xhr);
        },

        rangeChangeBrowser: function(e) {
            var days = parseInt($(e.currentTarget).data('value'), 10);

            this.$el.find('.days-browser .current-selection').text('Last ' + days + ' days');
            this.$el.find('.days-browser li').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            var xhr = Cache.app.request({
                action: 'statistics/report',
                data: {
                    days: days,
                    type: 'browser'
                },
                context: this,
                success: function(response) {
                    this.renderBrowserChart(response.browser);
                }
            });

            this.pending_xhr.push(xhr);
        },

        rangeChangeCountry: function(e) {
            var days = parseInt($(e.currentTarget).data('value'), 10);

            this.$el.find('.days-country .current-selection').text('Last ' + days + ' days');
            this.$el.find('.days-country li').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            var xhr = Cache.app.request({
                action: 'statistics/report',
                data: {
                    days: days,
                    type: 'country'
                },
                context: this,
                success: function(response) {
                    this.renderCountryChart(response.country);
                }
            });

            this.pending_xhr.push(xhr);
        },

        rangeChangeTopUser: function(e) {
            var days = parseInt($(e.currentTarget).data('value'), 10);

            this.$el.find('.days-top-user .current-selection').text('Last ' + days + ' days');
            this.$el.find('.days-top-user li').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            var xhr = Cache.app.request({
                action: 'statistics/report',
                data: {
                    days: days,
                    type: 'top_user'
                },
                context: this,
                success: function(response) {
                    this.renderTopUserChart(response.top_user.feedback_total);
                }
            });

            this.pending_xhr.push(xhr);
        },

        onWidgetPreview: function(e) {
            this.rebuildWidgetStudio(null, false, 'demo');
        },

        onWidgetEdit: function(e) {
            this.rebuildWidgetStudio(undefined, false);
        },

        onWidgetToggle: function(e) {
            var widget = Cache.widget.findWhere({project_id: Cache.default_project_id});
            Modals.toggleWidget(widget);
        },

        onTryExtension: function(e) {
            e.preventDefault();

            Modals.tryBrowserExtension();
        },

        onTryExtensionClose: function(e) {
            Cache.app.addUserSetting('hide_try_extension', 1, false);
            this.$el.find('.try-extension-prompt').remove();
        },

        onActivatePortal: function(e) {
            e.preventDefault();

            if (!Cache.account.hasFeature('portal')) {
                Modals.unlockFeature(undefined, undefined, undefined, () => {
                    Modals.choosePlan(undefined, undefined, false, false, false, true);
                });
                return;
            }

            var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

            if (portal) {
                window.open(portal.getUrl(), 'portal');
            } else {
                Modals.activatePortal();
            }
        },

        onActivateAIAssist: function(e) {
            e.preventDefault();
            Modals.projectSettings(Cache.default_project_id, 'ai_assist');
        }
    },

    initialize: function() {
        var widget_setting = {
            bug             : null,
            feature_request : null,
            general         : null
        };

        Cache.widget_setting.where({project_id: Cache.default_project_id}).forEach((model) => {
            widget_setting[model.get('widget_type')] = model;
        });

        this.listenTo(Cache.widget, 'change', this.renderWidgetInfo);

        this.on('remove', function() {
            this.pending_xhr.forEach(function(pending_xhr) {
                pending_xhr.abort();
            });
        });
    },

    rebuildWidgetStudio: function(template_code = null, hide_animation = false, step = '') {
        if (window.location.pathname.indexOf('/dashboard/designer') === -1) {
            Router.navigate('/' + Cache.getDefaultProject().get('project_key') + '/dashboard/designer' + (step ? '?s=' + step : ''), {trigger: false});
        }

        Modals.openWidgetStudio(template_code, hide_animation, () => {
            Router.navigate('/' + Cache.getDefaultProject().get('project_key') + '/dashboard/', {trigger: false});
        });
    },

    updateWidgets: function() {
        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});
        var cached_data = Cache.get('dashboard_stats_' + Cache.default_project_id);

        var _render = (data) => {
            if (portal && Cache.account.hasFeature('portal')) {
                this.renderTopVoteChart(data.feedback_top_vote);
            }

            this.renderFeedbackType(data);
            this.renderFeedbackStatus(data);
            this.renderFeedbackAssignee(data);
            this.renderDesignChart();
            this.renderRatingChart(data.feedback_rating);

            Chart_Feedback_Activity.render(this.$el.find('#chart_feedback'), data.activity);

            Cache.user_identification.add(data.top_user.user_identification);

            this.renderUsageChart(data.usage);
            this.renderBrowserChart(data.browser);
            this.renderCountryChart(data.country);
            this.renderTopUserChart(data.top_user.feedback_total);
        };

        if (cached_data) {
            _render(cached_data);
        } else {
            var xhr = Cache.app.request({
                action: 'statistics/report',
                data: {
                    days: 30
                },
                success: (response) => {
                    Cache.add('dashboard_stats_' + Cache.default_project_id, response, false);
                    _render(response);
                }
            });

            this.pending_xhr.push(xhr);

            // loading placeholder
            this.renderFeedbackType();
        }
    },

    onPageReady: function() {
        if (window.location.pathname.indexOf('/dashboard/designer') >= 0) {
            this.rebuildWidgetStudio(null, true);
        } else if (Router.getQueryString('get_code')) {
            Modals.getWidgetCode(true);
        } else if (Router.getQueryString('project_settings')) {
            Modals.projectSettings(Cache.default_project_id);
        }

        this.updateWidgets();

        Modals.launchFeature();
    },

    renderFeedbackType: function(data) {
        if (this.views.feedback_type instanceof View_Feedback_Type) {
            this.views.feedback_type.remove();
        }

        this.views.feedback_type = new View_Feedback_Type({
            data: data
        });
        this.views.feedback_type.render().$el.appendTo(this.$el.find('.region-feedback-type'));
    },

    renderFeedbackStatus: function(data) {
        if (this.views.feedback_status instanceof View_Feedback_Status) {
            this.views.feedback_status.remove();
        }

        this.views.feedback_status = new View_Feedback_Status({
            data: data
        });
        this.views.feedback_status.render().$el.appendTo(this.$el.find('.region-feedback-status'));
    },

    renderFeedbackAssignee: function(data) {
        if (this.views.feedback_assignee instanceof View_Feedback_Assignee) {
            this.views.feedback_assignee.remove();
        }

        this.views.feedback_assignee = new View_Feedback_Assignee({
            data: data
        });
        this.views.feedback_assignee.render().$el.appendTo(this.$el.find('.region-feedback-assignee'));
    },

    renderUsageChart: function(response) {
        if (this.views.time_usage instanceof View_Feedback_Time_Usage) {
            this.views.time_usage.remove();
        }

        this.views.time_usage = new View_Feedback_Time_Usage(response);
        this.views.time_usage.render().$el.appendTo(this.$el.find('#chart_usage'));
    },

    renderTopVoteChart: function(data) {
        if (this.views.top_vote instanceof View_Feedback_Vote) {
            this.views.top_vote.remove();
        }

        this.views.top_vote = new View_Feedback_Vote({
            data: data
        });
        this.views.top_vote.render().$el.appendTo(this.$el.find('#chart_top_vote'));
    },

    renderDesignChart: function() {
        if (!Cache.account.hasFeature('image_feedback')) {
            return;
        }

        if (this.views.design_files instanceof View_Design_Files) {
            this.views.design_files.remove();
        }

        this.views.design_files = new View_Design_Files();
        this.views.design_files.render().$el.appendTo(this.$el.find('#chart_designs'));
    },

    renderRatingChart: function(data) {
        if (this.views.rating instanceof View_Feedback_Rating) {
            this.views.rating.remove();
        }

        this.views.rating = new View_Feedback_Rating({
            data: data
        });
        this.views.rating.render().$el.appendTo(this.$el.find('#chart_rating'));
    },

    renderTopUserChart: function(response) {
        if (this.views.top_user instanceof View_Feedback_Top_User) {
            this.views.top_user.remove();
        }

        this.views.top_user = new View_Feedback_Top_User(response);
        this.views.top_user.render().$el.appendTo(this.$el.find('#chart_top_user'));
    },

    renderBrowserChart: function(response) {
        if (this.views.browser_chart instanceof View_Browser) {
            this.views.browser_chart.remove();
        }

        this.views.browser_chart  = new View_Browser(response);
        this.views.browser_chart.render().$el.appendTo(this.$el.find('#chart_browser'));
    },

    renderCountryChart: function(response) {
        if (this.views.country_chart instanceof View_Country) {
            this.views.country_chart.remove();
        }

        this.views.country_chart = new View_Country(response);
        this.views.country_chart.render().$el.appendTo(this.$el.find('#chart_country'));
    },

    renderWidgetInfo: function() {
        var widget_model = Cache.widget.findWhere({project_id: Cache.default_project_id});

        var audience = 'Anyone';

        if (widget_model.get('user_segment')) {
            var segment = Cache.user_segment.get(widget_model.get('user_segment'));

            if (segment) {
                audience = segment.escape('segment_name');
            }
        }

        var pages = 'All pages';

        if (widget_model.get('trigger_type') === 'url_match' && widget_model.get('page_condition')) {
            try {
                var data = JSON.parse(widget_model.get('page_condition'));

                if (data.conditions && data.conditions[0]) {
                    pages = '<span class="tooltip" data-title="' + ((page_conditions[data.conditions[0].type] || '') + ' ' + Util.htmlEntities(data.conditions[0].value)) + '">Specific pages</span>';
                }
            } catch (e) {
            }
        }

        var devices = 'All devices';

        if (widget_model.get('device_type').split(',').length < 3) {
            widget_model.get('device_type') ? widget_model.get('device_type').split(',').map((val) => {
                return Util.cap(val);
            }).join(', ') : 'None';
        }


        var feedback_type = '';

        if (widget_model.isNextGen()) {
            if (widget_model.get('ai_feedback_type')) {
                feedback_type = 'General, Idea, Bug';
            } else {
                feedback_type = widget_model.get('feedback_type') ? widget_model.get('feedback_type').split(',').map((val) => {
                    return feedback_type_options[val] || '';
                }).join(', ') : 'None';
            }
        } else {
            feedback_type = widget_model.get('workflow_type') ? widget_model.get('workflow_type').split(',').map((val) => {
                return feedback_type_options[val] || '';
            }).join(', ') : 'None';
        }

        var html =
        '<li>Segments: <span class="font-weight-semibold">' + audience + '</span></li>' +
        '<li>Pages: <span class="font-weight-semibold">' + pages + '</span></li>' +
        '<li>Devices: <span class="font-weight-semibold">' + devices + '</span></li>' +
        '<li><span class="font-weight-semibold">' + feedback_type + '</span></li>';

        this.$el.find('.widget-info').html(html);



        this.$el.find('.widget-status').html(
        (Cache.app.isAdmin() ?

        (widget_model.get('is_active') ?
        '<div class="button-dropdown">' +
            '<button type="button" class="status-dropdown status-dropdown-success" data-size="small">Live</button>' +
            '<div>' +
                '<ul class="dropdown">' +
                    '<li class="widget-toggle">Pause</li>' +
                '</ul>' +
            '</div>' +
        '</div>' :
        '<div class="button-dropdown">' +
            '<button type="button" class="status-dropdown status-dropdown-attention" data-size="small">Paused</button>' +
            '<div>' +
                '<ul class="dropdown">' +
                    '<li class="widget-toggle">Set Live</li>' +
                '</ul>' +
            '</div>' +
        '</div>') :

        (widget_model.get('is_active') ?
        '<button type="button" class="status-btn status-btn-success" data-size="small">Live</button>' :
        '<button type="button" class="status-btn status-btn-attention" data-size="small">Paused</button>')));
    },

    render: function() {
        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

        var content = '<div class="aside-grid-medium">';

        content += '<div>';

        content +=     '<h3 class="widget-title"><b>Feedback</b></h3>';
        // feedback type
        content +=     '<div class="region-feedback-type margin-bottom-32"></div>';
        // feedback status
        content +=     '<div class="region-feedback-status margin-bottom-36"></div>';

        // top voted ideas
        if (portal && Cache.account.hasFeature('portal')) {
            content +=
            '<h3 class="widget-title"><b>Top voted ideas</b></h3>' +
            '<div class="box box-nopadding margin-bottom-36">' +
                '<div id="chart_top_vote" class="overflow-x-auto"></div>' +
            '</div>';
        }

        // Rating
        content +=     '<h3 class="widget-title"><b>Rating</b></h3>' +
                    '<div class="box box-nopadding margin-bottom-36">' +
                        '<div id="chart_rating"></div>' +
                    '</div>';

        // Assignee
        content +=     '<div class="region-feedback-assignee margin-bottom-36"></div>';

        content +=     '<h3 class="widget-title"><b>Feedback by status</b> <span class="data-from info hidden">(from 01 Dec 2017)</span></h3>' +
                    '<div class="box margin-bottom-36">' +
                        '<div class="button-dropdown time-selector days-activity">' +
                            '<button class="text-invert square small inline"><span class="current-selection text-info">Last 30 Days</span> <i class="fa-regular fa-chevron-down text-icon"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li data-value="30" class="selected">Last 30 Days</li>' +
                                    '<li data-value="60">Last 60 Days</li>' +
                                    '<li data-value="90">Last 90 Days</li>' +
                                    '<li data-value="120">Last 120 Days</li>' +
                                    '<li data-value="360">Last 360 Days</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div id="chart_feedback"></div>' +
                    '</div>';

        content +=     '<h3 class="widget-title"><b>Feedback by time of day</b></h3>' +
                    '<div class="box margin-bottom-36">' +
                        '<div class="button-dropdown time-selector days-usage">' +
                            '<button class="text-invert square small inline"><span class="current-selection text-info">Last 30 Days</span> <i class="fa-regular fa-chevron-down text-icon"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li data-value="30" class="selected">Last 30 Days</li>' +
                                    '<li data-value="60">Last 60 Days</li>' +
                                    '<li data-value="90">Last 90 Days</li>' +
                                    '<li data-value="120">Last 120 Days</li>' +
                                    '<li data-value="360">Last 360 Days</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div id="chart_usage"></div>' +
                    '</div>';

        content +=     '<h3 class="widget-title"><b>Top users</b></h3>' +
                    '<div class="box box-nopadding margin-bottom-36">' +
                        '<div class="button-dropdown time-selector days-top-user">' +
                            '<button class="text-invert square small inline"><span class="current-selection text-info">Last 30 Days</span> <i class="fa-regular fa-chevron-down text-icon"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li data-value="30" class="selected">Last 30 Days</li>' +
                                    '<li data-value="60">Last 60 Days</li>' +
                                    '<li data-value="90">Last 90 Days</li>' +
                                    '<li data-value="120">Last 120 Days</li>' +
                                    '<li data-value="360">Last 360 Days</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div id="chart_top_user"></div>' +
                    '</div>';

        content +=     '<h3 class="widget-title"><b>Browser & OS</b></h3>' +
                    '<div class="box box-nopadding margin-bottom-36">' +
                        '<div class="button-dropdown time-selector days-browser">' +
                            '<button class="text-invert square small inline"><span class="current-selection text-info">Last 30 Days</span> <i class="fa-regular fa-chevron-down text-icon"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li data-value="30" class="selected">Last 30 Days</li>' +
                                    '<li data-value="60">Last 60 Days</li>' +
                                    '<li data-value="90">Last 90 Days</li>' +
                                    '<li data-value="120">Last 120 Days</li>' +
                                    '<li data-value="360">Last 360 Days</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div id="chart_browser" class="overflow-auto"></div>' +
                    '</div>';

        content +=     '<h3 class="widget-title"><b>Location</b></h3>' +
                    '<div class="box box-nopadding">' +
                        '<div class="button-dropdown time-selector days-country">' +
                            '<button class="text-invert square small inline"><span class="current-selection text-info">Last 30 Days</span> <i class="fa-regular fa-chevron-down text-icon"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li data-value="30" class="selected">Last 30 Days</li>' +
                                    '<li data-value="60">Last 60 Days</li>' +
                                    '<li data-value="90">Last 90 Days</li>' +
                                    '<li data-value="120">Last 120 Days</li>' +
                                    '<li data-value="360">Last 360 Days</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div id="chart_country"></div>' +
                    '</div>';

        // Designs
        if (Cache.account.hasFeature('image_feedback')) {
            content +=   '<h3 class="widget-title"><b>Design Files</b></h3>' +
                        '<div class="box box-nopadding">' +
                            '<div id="chart_designs" class="overflow-x-auto"></div>' +
                        '</div>';
        }

        content += '</div>';

        content +=
            '<aside>' +
                '<div class="box-small-large">' +
                    '<h3 class="font-weight-semibold flex-start">' +
                        '<span class="margin-right-8">Widget</span>' +
                        '<div class="widget-status"></div>' +
                    '</h3>' +
                    '<div class="position-relative">' +
                        '<ul class="widget-info"></ul>' +
                        '<div class="widget-info-btn">' +
                            '<button type="button" class="widget-preview small tertiary min">Preview</button>' +
                            (Cache.app.isAdmin() ?
                            '<button type="button" class="widget-edit small tertiary min margin-left-8">Edit Widget</button>' : '') +
                        '</div>' +
                    '</div>' +
                '</div>' +

                (Cache.app.getUserSetting('hide_try_extension') ? '' :
                '<div class="try-extension-prompt box-neutral position-relative">' +
                    '<button type="button" class="try-extension-close btn-close-tiny"><i class="fa-solid fa-xmark"></i></button>' +
                    '<div class="text-info margin-bottom-8">Not ready to install the code?</div>' +
                    '<a href="#" class="try-extension primary font-weight-medium">Try the Browser Extension <i class="fa-solid fa-square-arrow-up-right"></i></a>' +
                '</div>') +

                '<div class="portal-box box-neutral margin-top-24">' +
                    '<div class="text-info margin-bottom-8">Manage ideas in a public ideas portal</div>' +
                    '<a href="#" class="activate-portal primary font-weight-medium">Ideas Portal <i class="fa-solid fa-square-arrow-up-right"></i></a>' +
                '</div>' +

                '<div class="portal-box box-neutral margin-top-24">' +
                    '<div class="text-info margin-bottom-8"><i class="fa-solid fa-sparkles"></i> AI Assists in feedback management</div>' +
                    '<a href="#" class="ai-assist primary font-weight-medium">Set it up <i class="fa-solid fa-square-arrow-up-right"></i></a>' +
                '</div>' +
            '</aside>';

        content += '</div>';

        this.$el.html(content);

        this.renderWidgetInfo();

        return this;
    }
});

export default Page_Dashboard;
